import { Dialog, DialogContent, DialogHeader, DialogTitle, DialogDescription } from '@/components/ui/dialog';
import BillingDraftCreator from './BillingDraftCreator';

type BillingDraftCreatorDialogProps = {
    open: boolean;
    onOpenChange: (open: boolean) => void;
    preselectedCustomerId?: number;
    preselectedAppointmentId?: string;
    onSuccess: (billingDraftId: string) => void;
};

const BillingDraftCreatorDialog = ({
    open,
    onOpenChange,
    preselectedCustomerId,
    preselectedAppointmentId,
    onSuccess,
}: BillingDraftCreatorDialogProps) => {
    return (
        <Dialog open={open} onOpenChange={onOpenChange}>
            <DialogContent className='max-w-5xl max-h-[90vh] overflow-y-auto'>
                <DialogHeader>
                    <DialogTitle>Auftrag erstellen</DialogTitle>
                    <DialogDescription>
                        Erstellen Sie einen neuen Auftrag für den Kunden.
                    </DialogDescription>
                </DialogHeader>
                <BillingDraftCreator
                    preselectedCustomerId={preselectedCustomerId}
                    preselectedAppointmentId={preselectedAppointmentId}
                    onSuccess={(billingDraftId) => {
                        onSuccess(billingDraftId);
                    }}
                    onCancel={() => onOpenChange(false)}
                    hideWrapper
                    defaultTab="lineItems"
                />
            </DialogContent>
        </Dialog>
    );
};

export default BillingDraftCreatorDialog;
